<script>
    import { setupI18n, _ } from './i18n';
    import {apiRequest} from "./lib/Request.svelte";
    import RangeSlider from "svelte-range-slider-pips";
    import { onMount, onDestroy } from 'svelte';
    import NumberInput from "./lib/NumberInput.svelte";

    onMount(() => {
        document.addEventListener('rangeValueChange', onRangeValueChange, {
            capture: true
        });
    })

    onDestroy(() => {
        document.removeEventListener('click', onRangeValueChange, {
            capture: true
        });
    })

    function onRangeValueChange(event) {
        if (currentBlock !== event.detail.blockName) {
            sliderValue = event.detail.newValue;
            inputValue = sliderValue[0];
            calcPrice();
        }
    }

    function onSliderValueChange() {
        document.dispatchEvent(new CustomEvent('rangeValueChange', {
            detail: {
                newValue: sliderValue,
                blockName: currentBlock,
            }
        }));
        calcPrice();
        inputValue = sliderValue[0];
    }

    export let showCalculator = false;
    export let currentBlock;

    export let priceMultiplier = 1;

    export let locale;

    export let regButtonId = null;
    let regButtonIdAlt = regButtonId;


        setupI18n({ withLocale: locale });


    export let minFollowers = 4999;
    export let maxFollowers = 100001

    export let sliderValue = [minFollowers];

    export let minPrice = 47;
    export let maxPrice = 300;
    export let price5k = 54;
    export let price10k = 69;
    export let price20k = 75;
    export let price50k = 95;
    export let price100k = 130;

    export let priceCoef = 0.00253;

    let price = minPrice;
    function calcPriceOld() {
        try {
            if (sliderValue[0] === minFollowers) {
                price = minPrice;
            } else if (sliderValue[0] === maxFollowers) {
                price = maxPrice;
            } else {
                price = (minPrice + sliderValue[0] * priceCoef).toFixed(2);
            }
        } catch (err) {}
    }

    function calcPrice() {
        const amount = sliderValue[0];
        if (amount < 5000) {
            price = minPrice;
        } else if (amount < 10000) {
            price = price5k;
        } else if (amount < 20000) {
            price = price10k;
        } else if (amount < 50000) {
            price = price20k;
        } else if (amount <= 100000) {
            price = price100k;
        } else {
            price = maxPrice;
        }

        price = locale === 'ru-RU'
            ? Math.round(Math.round(price * priceMultiplier * 10) / 10).toLocaleString('ru-RU')
            : (price * priceMultiplier).toFixed(2);
    }

    let inputValue = sliderValue[0];
    $: inputValue && (sliderValue = [inputValue]);
    $: inputValue && onSliderValueChange();


    calcPrice();

    const toReg = (e) => {
        if (locale === 'ru-RU') {
            localStorage.setItem('selectedTariffRU', e.target.id)
            userAutoRegister();
            return;
        }
        location.href = e.target.href
    }
</script>

<div class="calculator-widget-wrap {sliderValue[0] < 24000 ? 'min-value' : ''}
    {sliderValue[0] > (locale === 'ru-RU' ? 35000 : 74000) ? 'max-value' : ''}">
    <div class="intro-wrap mb-30px">
        {#if locale === 'ru-RU'}
            <svg style="margin: 0 5px auto -7px;" width="40" height="40" viewBox="0 5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.21851 0.240234H14.7815C15.9752 0.240234 16.9519 1.21692 16.9519 2.41065V16.591C16.9519 17.7847 15.9752 18.7614 14.7815 18.7614H4.21851C3.02481 18.7614 2.0481 17.7847 2.0481 16.591V2.41065C2.0481 1.21688 3.02478 0.240234 4.21851 0.240234ZM13.0087 14.3803C12.8084 14.3803 12.6265 14.4621 12.4948 14.5938C12.3631 14.7254 12.2813 14.9074 12.2813 15.1077V15.8313C12.2813 16.0316 12.3631 16.2136 12.4948 16.3453C12.6265 16.477 12.8084 16.5587 13.0087 16.5587H14.673C14.8732 16.5587 15.0552 16.477 15.1869 16.3453C15.3186 16.2136 15.4004 16.0316 15.4004 15.8313V15.1077C15.4004 14.9074 15.3186 14.7255 15.1869 14.5938C15.0552 14.4621 14.8732 14.3803 14.673 14.3803H13.0087ZM14.673 14.8948H13.0087C12.9505 14.8948 12.8972 14.9188 12.8586 14.9575C12.8199 14.9961 12.7959 15.0494 12.7959 15.1077V15.8313C12.7959 15.8897 12.8199 15.9429 12.8586 15.9816C12.8972 16.0202 12.9505 16.0443 13.0087 16.0443H14.673C14.7313 16.0443 14.7845 16.0202 14.8232 15.9816C14.8618 15.9429 14.8859 15.8897 14.8859 15.8313V15.1077C14.8859 15.0494 14.8619 14.9961 14.8232 14.9575C14.7845 14.9188 14.7313 14.8948 14.673 14.8948ZM8.66785 14.3803C8.46757 14.3803 8.28562 14.4621 8.15392 14.5938C8.02222 14.7255 7.94043 14.9074 7.94043 15.1077V15.8313C7.94043 16.0316 8.02226 16.2136 8.15392 16.3453C8.28562 16.477 8.46757 16.5587 8.66785 16.5587H10.332C10.5323 16.5587 10.7142 16.477 10.8459 16.3453C10.9777 16.2136 11.0594 16.0316 11.0594 15.8313V15.1077C11.0594 14.9074 10.9776 14.7255 10.8459 14.5938C10.7142 14.4621 10.5323 14.3803 10.332 14.3803H8.66785ZM10.3321 14.8948H8.66789C8.60955 14.8948 8.5563 14.9188 8.51767 14.9575C8.479 14.9961 8.45495 15.0494 8.45495 15.1077V15.8313C8.45495 15.8897 8.479 15.9429 8.51767 15.9816C8.5563 16.0202 8.60955 16.0443 8.66789 16.0443H10.3321C10.3904 16.0443 10.4436 16.0202 10.4823 15.9816C10.5209 15.9429 10.545 15.8897 10.545 15.8313V15.1077C10.545 15.0494 10.5209 14.9961 10.4823 14.9575C10.4436 14.9188 10.3904 14.8948 10.3321 14.8948ZM4.32702 14.3803C4.12674 14.3803 3.94479 14.4621 3.81309 14.5938C3.68139 14.7255 3.5996 14.9074 3.5996 15.1077V15.8313C3.5996 16.0316 3.68139 16.2136 3.81309 16.3453C3.94479 16.477 4.12674 16.5587 4.32702 16.5587H5.99123C6.19151 16.5587 6.37345 16.477 6.50515 16.3453C6.63686 16.2136 6.71864 16.0316 6.71864 15.8313V15.1077C6.71864 14.9074 6.63686 14.7255 6.50515 14.5938C6.37345 14.4621 6.19151 14.3803 5.99123 14.3803H4.32702ZM5.99119 14.8948H4.32698C4.26865 14.8948 4.21543 14.9188 4.17676 14.9575C4.13813 14.9961 4.11405 15.0494 4.11405 15.1077V15.8313C4.11405 15.8897 4.1381 15.9429 4.17676 15.9816C4.21543 16.0202 4.26865 16.0443 4.32698 16.0443H5.99119C6.04953 16.0443 6.10274 16.0202 6.14141 15.9816C6.18004 15.9429 6.20412 15.8897 6.20412 15.8313V15.1077C6.20412 15.0494 6.18008 14.9961 6.14141 14.9575C6.10274 14.9188 6.04953 14.8948 5.99119 14.8948ZM13.0087 11.414C12.8084 11.414 12.6265 11.4958 12.4948 11.6275C12.3631 11.7592 12.2813 11.9411 12.2813 12.1414V12.865C12.2813 13.0653 12.3631 13.2473 12.4948 13.379C12.6265 13.5107 12.8084 13.5924 13.0087 13.5924H14.673C14.8732 13.5924 15.0552 13.5106 15.1869 13.379C15.3186 13.2473 15.4004 13.0653 15.4004 12.865V12.1414C15.4004 11.9411 15.3186 11.7592 15.1869 11.6275C15.0552 11.4958 14.8732 11.414 14.673 11.414H13.0087ZM14.673 11.9285H13.0087C12.9505 11.9285 12.8972 11.9525 12.8586 11.9912C12.8199 12.0298 12.7959 12.0831 12.7959 12.1414V12.8651C12.7959 12.9234 12.8199 12.9766 12.8586 13.0153C12.8972 13.0539 12.9505 13.078 13.0087 13.078H14.673C14.7313 13.078 14.7845 13.054 14.8232 13.0153C14.8618 12.9766 14.8859 12.9234 14.8859 12.8651V12.1414C14.8859 12.0831 14.8619 12.0298 14.8232 11.9912C14.7845 11.9525 14.7313 11.9285 14.673 11.9285ZM8.66785 11.414C8.46757 11.414 8.28562 11.4958 8.15392 11.6275C8.02222 11.7592 7.94043 11.9411 7.94043 12.1414V12.865C7.94043 13.0653 8.02226 13.2473 8.15392 13.379C8.28562 13.5107 8.46757 13.5924 8.66785 13.5924H10.332C10.5323 13.5924 10.7142 13.5106 10.8459 13.379C10.9777 13.2473 11.0594 13.0653 11.0594 12.865V12.1414C11.0594 11.9411 10.9776 11.7592 10.8459 11.6275C10.7142 11.4958 10.5323 11.414 10.332 11.414H8.66785ZM10.3321 11.9285H8.66789C8.60955 11.9285 8.5563 11.9525 8.51767 11.9912C8.479 12.0298 8.45495 12.0831 8.45495 12.1414V12.8651C8.45495 12.9234 8.479 12.9766 8.51767 13.0153C8.5563 13.0539 8.60955 13.078 8.66789 13.078H10.3321C10.3904 13.078 10.4436 13.054 10.4823 13.0153C10.5209 12.9766 10.545 12.9234 10.545 12.8651V12.1414C10.545 12.0831 10.5209 12.0298 10.4823 11.9912C10.4436 11.9525 10.3904 11.9285 10.3321 11.9285ZM4.32702 11.414C4.12674 11.414 3.94479 11.4958 3.81309 11.6275C3.68139 11.7592 3.5996 11.9411 3.5996 12.1414V12.865C3.5996 13.0653 3.68139 13.2473 3.81309 13.379C3.94479 13.5107 4.12674 13.5924 4.32702 13.5924H5.99123C6.19151 13.5924 6.37345 13.5106 6.50515 13.379C6.63686 13.2473 6.71864 13.0653 6.71864 12.865V12.1414C6.71864 11.9411 6.63686 11.7592 6.50515 11.6275C6.37345 11.4958 6.19151 11.414 5.99123 11.414H4.32702ZM5.99119 11.9285H4.32698C4.26865 11.9285 4.21543 11.9525 4.17676 11.9912C4.13813 12.0298 4.11405 12.0831 4.11405 12.1414V12.8651C4.11405 12.9234 4.1381 12.9766 4.17676 13.0153C4.21543 13.0539 4.26865 13.078 4.32698 13.078H5.99119C6.04953 13.078 6.10274 13.054 6.14141 13.0153C6.18004 12.9766 6.20412 12.9234 6.20412 12.8651V12.1414C6.20412 12.0831 6.18008 12.0298 6.14141 11.9912C6.10274 11.9525 6.04953 11.9285 5.99119 11.9285ZM13.0087 8.44768C12.8084 8.44768 12.6265 8.5295 12.4948 8.66117C12.3631 8.79287 12.2813 8.97482 12.2813 9.1751V9.89873C12.2813 10.099 12.3631 10.281 12.4948 10.4127C12.6265 10.5444 12.8084 10.6261 13.0087 10.6261H14.673C14.8732 10.6261 15.0552 10.5443 15.1869 10.4127C15.3186 10.281 15.4004 10.099 15.4004 9.89873V9.1751C15.4004 8.97482 15.3186 8.79287 15.1869 8.66117C15.0552 8.52947 14.8732 8.44768 14.673 8.44768H13.0087ZM14.673 8.9622H13.0087C12.9505 8.9622 12.8972 8.98625 12.8586 9.02491C12.8199 9.06355 12.7959 9.1168 12.7959 9.17513V9.89877C12.7959 9.9571 12.8199 10.0104 12.8586 10.049C12.8972 10.0876 12.9505 10.1117 13.0087 10.1117H14.673C14.7313 10.1117 14.7845 10.0877 14.8232 10.049C14.8618 10.0103 14.8859 9.9571 14.8859 9.89877V9.17513C14.8859 9.1168 14.8619 9.06355 14.8232 9.02491C14.7845 8.98625 14.7313 8.9622 14.673 8.9622ZM8.66785 8.44768C8.46757 8.44768 8.28562 8.5295 8.15392 8.66117C8.02222 8.79287 7.94043 8.97482 7.94043 9.1751V9.89873C7.94043 10.099 8.02226 10.281 8.15392 10.4127C8.28562 10.5444 8.46757 10.6261 8.66785 10.6261H10.332C10.5323 10.6261 10.7142 10.5443 10.8459 10.4127C10.9777 10.281 11.0594 10.099 11.0594 9.89873V9.1751C11.0594 8.97482 10.9776 8.79287 10.8459 8.66117C10.7142 8.52947 10.5323 8.44768 10.332 8.44768H8.66785ZM10.3321 8.9622H8.66789C8.60955 8.9622 8.5563 8.98625 8.51767 9.02491C8.479 9.06355 8.45495 9.1168 8.45495 9.17513V9.89877C8.45495 9.9571 8.479 10.0104 8.51767 10.049C8.5563 10.0876 8.60955 10.1117 8.66789 10.1117H10.3321C10.3904 10.1117 10.4436 10.0877 10.4823 10.049C10.5209 10.0103 10.545 9.9571 10.545 9.89877V9.17513C10.545 9.1168 10.5209 9.06355 10.4823 9.02491C10.4436 8.98625 10.3904 8.9622 10.3321 8.9622ZM4.32702 8.44768C4.12674 8.44768 3.94479 8.5295 3.81309 8.66117C3.68139 8.79287 3.5996 8.97482 3.5996 9.1751V9.89873C3.5996 10.099 3.68139 10.281 3.81309 10.4127C3.94479 10.5444 4.12674 10.6261 4.32702 10.6261H5.99123C6.19151 10.6261 6.37345 10.5443 6.50515 10.4127C6.63686 10.281 6.71864 10.099 6.71864 9.89873V9.1751C6.71864 8.97482 6.63686 8.79287 6.50515 8.66117C6.37345 8.52947 6.19151 8.44768 5.99123 8.44768H4.32702ZM5.99119 8.9622H4.32698C4.26865 8.9622 4.21543 8.98625 4.17676 9.02491C4.13813 9.06355 4.11405 9.1168 4.11405 9.17513V9.89877C4.11405 9.9571 4.1381 10.0104 4.17676 10.049C4.21543 10.0876 4.26865 10.1117 4.32698 10.1117H5.99119C6.04953 10.1117 6.10274 10.0877 6.14141 10.049C6.18004 10.0103 6.20412 9.9571 6.20412 9.89877V9.17513C6.20412 9.1168 6.18008 9.06355 6.14141 9.02491C6.10274 8.98625 6.04953 8.9622 5.99119 8.9622ZM4.45738 2.51511C4.22133 2.51511 4.00669 2.6116 3.85139 2.7669C3.69609 2.9222 3.5996 3.13673 3.5996 3.3729V6.29563C3.5996 6.53168 3.69609 6.74632 3.85139 6.90163C4.00669 7.05693 4.22133 7.15345 4.45738 7.15345H14.5426C14.7787 7.15345 14.9933 7.05697 15.1486 6.90163C15.3039 6.74632 15.4003 6.53168 15.4003 6.29563V3.37293C15.4003 3.13677 15.3039 2.92224 15.1486 2.76694C14.9933 2.61163 14.7787 2.51515 14.5426 2.51515L4.45738 2.51511Z" fill="#AFABF0"/>
            </svg>
        {:else}
            <svg class="icon" width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2.21851 0.23938H12.7815C13.9752 0.23938 14.9519 1.21606 14.9519 2.4098V16.5901C14.9519 17.7839 13.9752 18.7605 12.7815 18.7605H2.21851C1.02481 18.7605 0.0480957 17.7838 0.0480957 16.5901V2.4098C0.0480957 1.21602 1.02478 0.23938 2.21851 0.23938ZM11.0087 14.3794C10.8084 14.3794 10.6265 14.4613 10.4948 14.5929C10.3631 14.7246 10.2813 14.9066 10.2813 15.1068V15.8305C10.2813 16.0308 10.3631 16.2127 10.4948 16.3444C10.6265 16.4761 10.8084 16.5579 11.0087 16.5579H12.673C12.8732 16.5579 13.0552 16.4761 13.1869 16.3444C13.3186 16.2127 13.4004 16.0308 13.4004 15.8305V15.1068C13.4004 14.9066 13.3186 14.7246 13.1869 14.5929C13.0552 14.4612 12.8732 14.3794 12.673 14.3794H11.0087ZM12.673 14.8939H11.0087C10.9505 14.8939 10.8972 14.918 10.8586 14.9566C10.8199 14.9953 10.7959 15.0485 10.7959 15.1068V15.8305C10.7959 15.8888 10.8199 15.942 10.8586 15.9807C10.8972 16.0193 10.9505 16.0434 11.0087 16.0434H12.673C12.7313 16.0434 12.7845 16.0194 12.8232 15.9807C12.8618 15.942 12.8859 15.8888 12.8859 15.8305V15.1068C12.8859 15.0485 12.8619 14.9953 12.8232 14.9566C12.7845 14.918 12.7313 14.8939 12.673 14.8939ZM6.66785 14.3794C6.46757 14.3794 6.28562 14.4613 6.15392 14.5929C6.02222 14.7246 5.94043 14.9066 5.94043 15.1068V15.8305C5.94043 16.0308 6.02226 16.2127 6.15392 16.3444C6.28562 16.4761 6.46757 16.5579 6.66785 16.5579H8.33202C8.5323 16.5579 8.71425 16.4761 8.84595 16.3444C8.97765 16.2127 9.05944 16.0308 9.05944 15.8305V15.1068C9.05944 14.9066 8.97761 14.7246 8.84595 14.5929C8.71425 14.4612 8.5323 14.3794 8.33202 14.3794H6.66785ZM8.33206 14.8939H6.66789C6.60955 14.8939 6.5563 14.918 6.51767 14.9566C6.479 14.9953 6.45495 15.0485 6.45495 15.1068V15.8305C6.45495 15.8888 6.479 15.942 6.51767 15.9807C6.5563 16.0193 6.60955 16.0434 6.66789 16.0434H8.33206C8.39039 16.0434 8.44365 16.0194 8.48228 15.9807C8.52095 15.942 8.54499 15.8888 8.54499 15.8305V15.1068C8.54499 15.0485 8.52095 14.9953 8.48228 14.9566C8.44361 14.918 8.39039 14.8939 8.33206 14.8939ZM2.32702 14.3794C2.12674 14.3794 1.94479 14.4613 1.81309 14.5929C1.68139 14.7246 1.5996 14.9066 1.5996 15.1068V15.8305C1.5996 16.0308 1.68139 16.2127 1.81309 16.3444C1.94479 16.4761 2.12674 16.5579 2.32702 16.5579H3.99123C4.19151 16.5579 4.37345 16.4761 4.50515 16.3444C4.63686 16.2127 4.71864 16.0308 4.71864 15.8305V15.1068C4.71864 14.9066 4.63686 14.7246 4.50515 14.5929C4.37345 14.4612 4.19151 14.3794 3.99123 14.3794H2.32702ZM3.99119 14.8939H2.32698C2.26865 14.8939 2.21543 14.918 2.17676 14.9566C2.13813 14.9953 2.11405 15.0485 2.11405 15.1068V15.8305C2.11405 15.8888 2.1381 15.942 2.17676 15.9807C2.21543 16.0193 2.26865 16.0434 2.32698 16.0434H3.99119C4.04953 16.0434 4.10274 16.0194 4.14141 15.9807C4.18004 15.942 4.20412 15.8888 4.20412 15.8305V15.1068C4.20412 15.0485 4.18008 14.9953 4.14141 14.9566C4.10274 14.918 4.04953 14.8939 3.99119 14.8939ZM11.0087 11.4131C10.8084 11.4131 10.6265 11.495 10.4948 11.6266C10.3631 11.7583 10.2813 11.9403 10.2813 12.1405V12.8642C10.2813 13.0645 10.3631 13.2464 10.4948 13.3781C10.6265 13.5098 10.8084 13.5916 11.0087 13.5916H12.673C12.8732 13.5916 13.0552 13.5098 13.1869 13.3781C13.3186 13.2464 13.4004 13.0645 13.4004 12.8642V12.1405C13.4004 11.9403 13.3186 11.7583 13.1869 11.6266C13.0552 11.4949 12.8732 11.4131 12.673 11.4131H11.0087ZM12.673 11.9276H11.0087C10.9505 11.9276 10.8972 11.9517 10.8586 11.9904C10.8199 12.029 10.7959 12.0822 10.7959 12.1406V12.8642C10.7959 12.9225 10.8199 12.9758 10.8586 13.0144C10.8972 13.0531 10.9505 13.0771 11.0087 13.0771H12.673C12.7313 13.0771 12.7845 13.0531 12.8232 13.0144C12.8618 12.9758 12.8859 12.9225 12.8859 12.8642V12.1406C12.8859 12.0822 12.8619 12.029 12.8232 11.9904C12.7845 11.9517 12.7313 11.9276 12.673 11.9276ZM6.66785 11.4131C6.46757 11.4131 6.28562 11.495 6.15392 11.6266C6.02222 11.7583 5.94043 11.9403 5.94043 12.1405V12.8642C5.94043 13.0645 6.02226 13.2464 6.15392 13.3781C6.28562 13.5098 6.46757 13.5916 6.66785 13.5916H8.33202C8.5323 13.5916 8.71425 13.5098 8.84595 13.3781C8.97765 13.2464 9.05944 13.0645 9.05944 12.8642V12.1405C9.05944 11.9403 8.97761 11.7583 8.84595 11.6266C8.71425 11.4949 8.5323 11.4131 8.33202 11.4131H6.66785ZM8.33206 11.9276H6.66789C6.60955 11.9276 6.5563 11.9517 6.51767 11.9904C6.479 12.029 6.45495 12.0822 6.45495 12.1406V12.8642C6.45495 12.9225 6.479 12.9758 6.51767 13.0144C6.5563 13.0531 6.60955 13.0771 6.66789 13.0771H8.33206C8.39039 13.0771 8.44365 13.0531 8.48228 13.0144C8.52095 12.9758 8.54499 12.9225 8.54499 12.8642V12.1406C8.54499 12.0822 8.52095 12.029 8.48228 11.9904C8.44361 11.9517 8.39039 11.9276 8.33206 11.9276ZM2.32702 11.4131C2.12674 11.4131 1.94479 11.495 1.81309 11.6266C1.68139 11.7583 1.5996 11.9403 1.5996 12.1405V12.8642C1.5996 13.0645 1.68139 13.2464 1.81309 13.3781C1.94479 13.5098 2.12674 13.5916 2.32702 13.5916H3.99123C4.19151 13.5916 4.37345 13.5098 4.50515 13.3781C4.63686 13.2464 4.71864 13.0645 4.71864 12.8642V12.1405C4.71864 11.9403 4.63686 11.7583 4.50515 11.6266C4.37345 11.4949 4.19151 11.4131 3.99123 11.4131H2.32702ZM3.99119 11.9276H2.32698C2.26865 11.9276 2.21543 11.9517 2.17676 11.9904C2.13813 12.029 2.11405 12.0822 2.11405 12.1406V12.8642C2.11405 12.9225 2.1381 12.9758 2.17676 13.0144C2.21543 13.0531 2.26865 13.0771 2.32698 13.0771H3.99119C4.04953 13.0771 4.10274 13.0531 4.14141 13.0144C4.18004 12.9758 4.20412 12.9225 4.20412 12.8642V12.1406C4.20412 12.0822 4.18008 12.029 4.14141 11.9904C4.10274 11.9517 4.04953 11.9276 3.99119 11.9276ZM11.0087 8.44682C10.8084 8.44682 10.6265 8.52865 10.4948 8.66031C10.3631 8.79201 10.2813 8.97396 10.2813 9.17424V9.89787C10.2813 10.0982 10.3631 10.2801 10.4948 10.4118C10.6265 10.5435 10.8084 10.6253 11.0087 10.6253H12.673C12.8732 10.6253 13.0552 10.5435 13.1869 10.4118C13.3186 10.2801 13.4004 10.0982 13.4004 9.89787V9.17424C13.4004 8.97396 13.3186 8.79201 13.1869 8.66031C13.0552 8.52861 12.8732 8.44682 12.673 8.44682H11.0087ZM12.673 8.96134H11.0087C10.9505 8.96134 10.8972 8.98539 10.8586 9.02406C10.8199 9.06269 10.7959 9.11594 10.7959 9.17428V9.89791C10.7959 9.95625 10.8199 10.0095 10.8586 10.0481C10.8972 10.0868 10.9505 10.1108 11.0087 10.1108H12.673C12.7313 10.1108 12.7845 10.0868 12.8232 10.0481C12.8618 10.0095 12.8859 9.95625 12.8859 9.89791V9.17428C12.8859 9.11594 12.8619 9.06269 12.8232 9.02406C12.7845 8.98539 12.7313 8.96134 12.673 8.96134ZM6.66785 8.44682C6.46757 8.44682 6.28562 8.52865 6.15392 8.66031C6.02222 8.79201 5.94043 8.97396 5.94043 9.17424V9.89787C5.94043 10.0982 6.02226 10.2801 6.15392 10.4118C6.28562 10.5435 6.46757 10.6253 6.66785 10.6253H8.33202C8.5323 10.6253 8.71425 10.5435 8.84595 10.4118C8.97765 10.2801 9.05944 10.0982 9.05944 9.89787V9.17424C9.05944 8.97396 8.97761 8.79201 8.84595 8.66031C8.71425 8.52861 8.5323 8.44682 8.33202 8.44682H6.66785ZM8.33206 8.96134H6.66789C6.60955 8.96134 6.5563 8.98539 6.51767 9.02406C6.479 9.06269 6.45495 9.11594 6.45495 9.17428V9.89791C6.45495 9.95625 6.479 10.0095 6.51767 10.0481C6.5563 10.0868 6.60955 10.1108 6.66789 10.1108H8.33206C8.39039 10.1108 8.44365 10.0868 8.48228 10.0481C8.52095 10.0095 8.54499 9.95625 8.54499 9.89791V9.17428C8.54499 9.11594 8.52095 9.06269 8.48228 9.02406C8.44361 8.98539 8.39039 8.96134 8.33206 8.96134ZM2.32702 8.44682C2.12674 8.44682 1.94479 8.52865 1.81309 8.66031C1.68139 8.79201 1.5996 8.97396 1.5996 9.17424V9.89787C1.5996 10.0982 1.68139 10.2801 1.81309 10.4118C1.94479 10.5435 2.12674 10.6253 2.32702 10.6253H3.99123C4.19151 10.6253 4.37345 10.5435 4.50515 10.4118C4.63686 10.2801 4.71864 10.0982 4.71864 9.89787V9.17424C4.71864 8.97396 4.63686 8.79201 4.50515 8.66031C4.37345 8.52861 4.19151 8.44682 3.99123 8.44682H2.32702ZM3.99119 8.96134H2.32698C2.26865 8.96134 2.21543 8.98539 2.17676 9.02406C2.13813 9.06269 2.11405 9.11594 2.11405 9.17428V9.89791C2.11405 9.95625 2.1381 10.0095 2.17676 10.0481C2.21543 10.0868 2.26865 10.1108 2.32698 10.1108H3.99119C4.04953 10.1108 4.10274 10.0868 4.14141 10.0481C4.18004 10.0095 4.20412 9.95625 4.20412 9.89791V9.17428C4.20412 9.11594 4.18008 9.06269 4.14141 9.02406C4.10274 8.98539 4.04953 8.96134 3.99119 8.96134ZM2.45738 2.51426C2.22133 2.51426 2.00669 2.61074 1.85139 2.76605C1.69609 2.92135 1.5996 3.13588 1.5996 3.37204V6.29478C1.5996 6.53083 1.69609 6.74547 1.85139 6.90077C2.00669 7.05608 2.22133 7.1526 2.45738 7.1526H12.5426C12.7787 7.1526 12.9933 7.05611 13.1486 6.90077C13.3039 6.74547 13.4003 6.53083 13.4003 6.29478V3.37208C13.4003 3.13592 13.3039 2.92139 13.1486 2.76608C12.9933 2.61078 12.7787 2.5143 12.5426 2.5143L2.45738 2.51426Z"
                      fill="url(#paint0_linear_315_2320)"/>
                <defs>
                    <linearGradient id="paint0_linear_315_2320" x1="2.19291" y1="21.173" x2="19.5128" y2="7.23579"
                                    gradientUnits="userSpaceOnUse">
                        <stop stop-color="#3766D0"/>
                        <stop offset="1" stop-color="#69248F"/>
                    </linearGradient>
                </defs>
            </svg>
        {/if}
        <span class={(locale === 'ru-RU' ? "text-wrap-ru" : "text-wrap")}>
            {$_('landing.knowPrice')}
        </span>
    </div>
                 <div class="range-wrap">
                    <RangeSlider min={minFollowers}
                                 max={maxFollowers}
                                 step={1}
                                 bind:values={sliderValue}
                                 pips={false}
                                 all="label"
                                 float
                                 suffix={" " + $_('landing.followers')}
                                 on:change={onSliderValueChange}
                                 handleFormatter={ function (v) {
                                     if (v === maxFollowers) {
                                         return '> 100 000';
                                     } else if (v === minFollowers) {
                                         return '< 5 000';
                                     }

                                     return v.toLocaleString('ru-RU');
                                 }}
                    />
                </div>

                <NumberInput bind:inputValue={inputValue} minValue={minFollowers} maxValue={maxFollowers} inputTimeout="2000" {locale} />

                <div class="controls-wrap">
                    {#if sliderValue[0] === minFollowers}
                        <a id={regButtonId} class="button button_gradient price-card__main-button price_select_button"
                           href="/signup" on:click|preventDefault={toReg}>
                            {$_('landing.priceLabelLow1k', {values: {price: price}})}
                            {#if locale === 'ru-RU'}
                                <img class = "loading-ico" src="/img/landing/main-square.gif" style="width: 28px; margin-left: -35px; position: relative; left: 40px;top: -2px;" alt = "loading" />
                            {/if}
                        </a>
                    {:else}
                        <a id={regButtonIdAlt} class="button button_gradient price-card__main-button price_select_button"
                           href="/signup" on:click|preventDefault={toReg}>
                            {$_('landing.priceLabel', {values: {price: price}})}
                            {#if locale === 'ru-RU'}
                                <img class = "loading-ico" src="/img/landing/main-square.gif" style="width: 28px; margin-left: -35px; position: relative; left: 40px;top: -2px;" alt = "loading" />
                            {/if}
                        </a>
                    {/if}
                </div>

</div>

<style>
    .input-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: -25px;
    }
    .input-wrap input {
        display: block;
        width: 91px;
        height: 31px;
        border: 1px solid #E8E8E8;
        border-radius: 8px;
        text-align: center;
        margin-right: 10px;
    }
    .input-wrap span {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        text-align: center;
        color: #23173D;
    }
    .intro-wrap {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin-top: 25px;
    }
    .intro-wrap .icon {
        width: 15px;
        margin-right: 10px;
    }
    .intro-wrap .text-wrap {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        color: #23173D;
    }

    @media (max-width:768px) {
        .calc-btn-wrap {
            flex: 0 0 100%;
            width: 100%;
        }

        .standard-tariffs > .month-wrap {
            margin-bottom: 30px;
        }
    }
    .standard-tariffs {
        display: flex;
        flex-wrap: wrap;
    }
    .standard-tariffs > div {
        flex-grow: 1;
    }
    .tariff-title {
        font-weight: 800;
        font-size: 24px;
        line-height: 29px;
        color: #FFFFFE;
    }
    .tariff-value {
        font-weight: 400;
        font-size: 24px;
        line-height: 29px;
        color: #FFFFFE;
    }
    .post-info-wrap {
        font-weight: 300;
        font-size: 14px;
        line-height: 17px;
        color: #F8F8FA;
    }
    .text-center {
        text-align: center;
    }
    .description-wrap {
        flex-grow: 1;
    }
    .description-wrap .row1 {
        font-weight: 300;
        font-size: 14px;
        line-height: 17px;
        color: #F8F8FA;
    }
    .description-wrap .row2 {
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #F8F8FA;
    }
    .calc-btn-wrap {
        width: 140px;
    }

    .blue-btn {
        display: block;
        height: 37px;
        background: linear-gradient(92.34deg, #606FE3 0%, #4783FE 100%);
        border-radius: 8px;
        color: #fff;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.07em;
        border: none;
    }
    .form-wrap {
        background: linear-gradient(119.6deg, #2C2346 -1.78%, #524A69 -1.77%, #23163D 100%);
        border: 1px solid #453E59;
        box-shadow: 7px 8px 13px rgba(0, 0, 0, 0.23);
        border-radius: 16px;
        color: #fff;
        padding: 42px 24px;
    }

    .form-wrap .intro-wrap {
        display: flex;
        flex-wrap: wrap;
    }

    .break {
        flex-basis: 100%;
        height: 0;
    }

    .inline {
        display: inline;
    }

    .mx-auto {
        margin-right: auto;
        margin-left: auto;
    }

    .mb-10px {
        margin-bottom: 10px;
    }
    .mb-20px {
        margin-bottom: 20px;
    }
    .mb-30px {
        margin-bottom: 30px;
    }
    .mb-40px {
        margin-bottom: 40px;
    }

    .mr-10px {
        margin-right: 10px;
    }
    .mr-21px {
        margin-right: 21px;
    }

    .w-40px {
        width: 40px;
    }
    .w-140px {
        width: 140px;
    }
    .maxw-140px {
        max-width: 140px;
    }
    .minw-40px {
        min-width: 40px;
    }

    @-moz-keyframes spin {
        100% { -moz-transform: rotate(360deg); }
    }
    @-webkit-keyframes spin {
        100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform:rotate(360deg);
        }
    }
    .spinner {
        -webkit-animation:spin 2s linear infinite;
        -moz-animation:spin 2s linear infinite;
        animation:spin 2s linear infinite;
    }


</style>